module.exports = __webpack_public_path__ + "assets/devices/KF-235-PG2-8f78d955f7b73f1e4dd873c56060ba15.svg";